import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import inputMask from '../../Utilities/MaskInput';
import { useSelector } from 'react-redux';

function PatientSignPopup({
  appId,
  handlePrint,
  handleClose,
  patientId,
  treatmentId,
  handleReload,
  setReloadListFlagTrue = () => {},
}) {
  const { user } = useSelector((state) => state.auth);
  const [allData, setAllData] = useState(false);
  const [handleRadio, setHandleRadio] = useState(1);
  const [mobile, setMobile] = useState('');
  const [mobileInput, setMobileInput] = useState('');
  const [email, setEmail] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [emailChkBox, setEmailChkBox] = useState(0);
  const [mobileChkBox, setMobileChkBox] = useState(0);
  const [editMobile, setEditMobile] = useState(false);
  const [editEmail, setEditEmail] = useState(false);

  const getPopupData = useCallback(async () => {
    try {
      const response = await post(
        'api/patient/TreatmentPlan/openPatSignInDatePopup',
        { patientId: patientId, treatmentId: treatmentId },
      );
      if (response.status === 200) {
        setAllData(response?.data);
        setMobile(response?.data?.mobile);
        setMobileInput(response?.data?.mobile);
        setEmail(response?.data?.email);
        setEmailInput(response?.data?.email);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  }, [patientId, treatmentId]);

  useEffect(() => {
    getPopupData();
  }, [getPopupData]);

  const handleSendTreatLink = useCallback(async () => {
    try {
      if (mobileChkBox || emailChkBox) {
        const response = await post(
          'api/patient/TreatmentPlan/sendPatientSigLink',
          {
            patientId: patientId,
            treatmentId: treatmentId,
            patMobileOption: mobileChkBox, //1 or 0
            patEmailOption: emailChkBox, //1 or 0
            appId: appId,
          },
        );
        if (response.status === 200) {
          handleReload();
          setReloadListFlagTrue();
          handleClose();
        }
      } else {
        setUiMessage('inf', 'Please select atleast one option.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  }, [
    mobileChkBox,
    emailChkBox,
    patientId,
    treatmentId,
    handleReload,
    setReloadListFlagTrue,
    handleClose,
    appId,
  ]);

  const handleManualSign = useCallback(async () => {
    try {
      if (patientId) {
        const response = await post(
          'api/patient/treatmentPlan/savePatSignInDate',
          {
            patientId: patientId,
            treatmentId: treatmentId,
            staffUserId: user?.id,
          },
        );
        if (response.status === 200) {
          handleReload();
          setReloadListFlagTrue();
          handleClose();
        }
      } else {
        setUiMessage('inf', 'Please select patient.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  }, [
    patientId,
    treatmentId,
    user?.id,
    handleReload,
    setReloadListFlagTrue,
    handleClose,
  ]);

  const handleUpdateMobile = useCallback(async () => {
    try {
      if (mobileInput) {
        const response = await post('api/patient/TreatmentPlan/savePatMobile', {
          patientId: patientId,
          mobileId: mobileInput,
          staffUserId: user?.id,
        });
        if (response.status === 200) {
          setMobile(mobileInput);
          setEditMobile(false);
        }
      } else {
        setUiMessage('inf', 'Please fill mobile number.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  }, [patientId, user?.id, mobileInput]);

  const handleUpdateEmail = useCallback(async () => {
    try {
      if (emailInput) {
        const response = await post('api/patient/TreatmentPlan/savePatEmail', {
          patientId: patientId,
          emailId: emailInput,
          staffUserId: user?.id,
        });
        if (response.status === 200) {
          setEmail(emailInput);
          setEditEmail(false);
        }
      } else {
        setUiMessage('inf', 'Please fill mobile number.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  }, [patientId, user?.id, emailInput]);

  return (
    <div className="modalBackground">
      <div className="cc-main-contnr" style={{ width: '575px' }}>
        <div
          className="cc-main-contnr-hdr"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <span style={{ display: 'flex' }}>
            <span className="cc-hdr-hdng">Patient Signature:</span>
            <span className="cc-hdr-nm">
              <span className="name">{allData?.patientName} </span>
              <span className="id">{`(#${allData?.chartNo})`} </span>
              <span className="age">- {allData?.age} </span>
              <span className="gender">{allData?.gender} </span>
            </span>
          </span>
          <span className="cc-hdr-cls cursor" onClick={handleClose}>
            X
          </span>
        </div>
        <div className="cc-main-contnr-bdy">
          <div className="auth-hdr">
            Select any <span style={{ color: 'orange' }}>One method</span> for
            patient signature
          </div>
          <div className="auth-bdy">
            <div className="cc-main-contnr-bdy-rw auth-sb-hdr">
              <span className="clear-left">
                <input
                  type="radio"
                  checked={handleRadio === 1}
                  name="cardAuthorization"
                  onChange={() => setHandleRadio(1)}
                />
              </span>
              <span
                className="clear-left10"
                style={{ width: '90%', color: 'orange' }}
              >
                Via Email or Text (Medgre will Send the patient signature link)
              </span>
            </div>
            <div className="cc-main-contnr-bdy-rw  p-chart-grid-alt">
              <span className="" style={{ marginLeft: '35px' }}>
                <input
                  type="checkbox"
                  className=""
                  name="patMobile"
                  checked={mobileChkBox}
                  onChange={(e) => setMobileChkBox(e.target.checked ? 1 : 0)}
                />
              </span>
              <span className="clear-left10 med-label">
                Send Text to
                {(editMobile && (
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: '10px',
                    }}
                  >
                    <input
                      type="text"
                      id="mobileId"
                      maxLength="10"
                      className="input-pat-sig"
                      style={{ width: '50%' }}
                      value={mobileInput}
                      onChange={(e) =>
                        setMobileInput(inputMask(e.target.value))
                      }
                    />
                    <span
                      className="button-submit clear-left10"
                      onClick={handleUpdateMobile}
                      style={{ width: '20%', padding: '3px' }}
                    >
                      Save
                    </span>
                    <span
                      className="button-cancel clear-left10"
                      style={{ width: '20%', padding: '3px' }}
                      onClick={() => setEditMobile(false)}
                    >
                      Cancel
                    </span>
                  </span>
                )) ||
                  (!editMobile && (
                    <>
                      <span className="clear-left10">{mobile}</span>
                      <span
                        className="clear-left10 bold cursor"
                        title="Change mobile"
                        onClick={() => setEditMobile(true)}
                      >
                        ✎
                      </span>
                    </>
                  ))}
              </span>
            </div>
            <div className="cc-main-contnr-bdy-rw">
              <span className="left clear-left" style={{ marginLeft: '35px' }}>
                <input
                  type="checkbox"
                  className="left"
                  name="patEmail"
                  checked={emailChkBox}
                  onChange={(e) => setEmailChkBox(e.target.checked ? 1 : 0)}
                />
              </span>
              <span className="left clear-left10 med-label">
                Send Email to{' '}
                {(editEmail && (
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: '10px',
                    }}
                  >
                    <input
                      type="text"
                      id="emailId"
                      maxLength="40"
                      className="input-pat-sig"
                      value={emailInput}
                      style={{ width: '50%' }}
                      onChange={(e) => setEmailInput(e.target.value)}
                    />
                    <span
                      id="emailSave"
                      className="button-submit clear-left10"
                      onClick={handleUpdateEmail}
                      style={{ width: '20%', padding: '3px' }}
                    >
                      Save
                    </span>
                    <span
                      id="emailCancel"
                      className="button-cancel"
                      style={{
                        marginLeft: '10px',
                        width: '20%',
                        padding: '3px',
                      }}
                      onClick={() => setEditEmail(false)}
                    >
                      Cancel
                    </span>
                  </span>
                )) ||
                  (!editEmail && (
                    <>
                      <span id="emailStrId" className="clear-left10">
                        {email}
                      </span>
                      <span
                        className="clear-left10 bold cursor"
                        title="Change email"
                        id="changeEmailId"
                        onClick={() => setEditEmail(true)}
                      >
                        ✎
                      </span>
                    </>
                  ))}
              </span>
            </div>
            <div className="cc-main-contnr-bdy-rw auth-sb-hdr">
              <span className="left clear-left">
                <input
                  type="radio"
                  checked={handleRadio === 2}
                  name="cardAuthorization"
                  onChange={() => setHandleRadio(2)}
                />
              </span>
              <span className="left clear-left10" style={{ color: 'orange' }}>
                Manually change the Signature status
              </span>
              <span className="left clear-left10">
                <select className="chzn-select">
                  <option value="unsigned">Unsigned</option>
                  <option value="signed">Signed</option>
                </select>
              </span>
            </div>
            <div className="cc-main-contnr-bdy-rw auth-sb-hdr">
              <span className="left clear-left">
                <input
                  type="radio"
                  checked={handleRadio === 3}
                  name="cardAuthorization"
                  onChange={() => setHandleRadio(3)}
                />
              </span>
              <span className="left clear-left10" style={{ color: 'orange' }}>
                Use QR Code to Sign the Treatment Plan via Link
              </span>
            </div>
            <div
              className={
                handleRadio === 3
                  ? 'left clear-left20'
                  : 'hide left clear-left20'
              }
            >
              <img src={allData?.qrCodeLink} alt="" />
            </div>
            <div
              className="cc-main-contnr-bdy-rw"
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <span className="left clear-left">
                Please print the treatment plan form and upload the signed copy
                to the Documents section.
              </span>
              <span className="left clear-left bold" onClick={handlePrint}>
                <Link>
                  <u>Print treatment plan form</u>
                </Link>
              </span>
            </div>
          </div>
        </div>
        <div
          className="cc-main-contnr-btn"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          {(handleRadio === 1 && (
            <span
              className="actn-yes width-unset"
              style={{ width: '165px !important' }}
              onClick={handleSendTreatLink}
            >
              Send Treatment Plan Link
            </span>
          )) || (
            <span
              className="button-disabled"
              style={{ width: '165px !important' }}
            >
              Send Treatment Plan Link
            </span>
          )}

          <span style={{ display: 'flex' }}>
            {(handleRadio === 2 && (
              <span
                className="actn-yes clear-right10 width-unset"
                onClick={handleManualSign}
              >
                Save
              </span>
            )) || <span className="button-disabled clear-right10">Save</span>}

            <span className="actn-No width-unset" onClick={handleClose}>
              Cancel
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default PatientSignPopup;
